import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import { money } from 'utils'

import Icon from 'discada/dist/Icon'
import { getPermission } from 'selectors/authSelectors'

import './EasyPencilSection.scss'

export class EasyPencilSection extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      open: true, //this.props.open,
    }

    this.toggle = () => this.setState({ open: !this.state.open })
  }

  render() {
    let { permit, permission } = this.props

    if (permit && !permission.r) return null

    let { title, className, children, summary } = this.props,
      { open } = this.state

    return (
      <div className={c('easy-pencil-section', className, { open })}>
        {false && title && (
          <h3 onClick={this.toggle}>
            <span>
              <Icon icon={open ? 'minus-square' : 'plus-square'} /> {title}{' '}
            </span>
            {typeof summary === 'number' && <small>{money(summary)}</small>}
          </h3>
        )}
        {(open || !title) && (
          <div className="easy-pencil-section-content">{children}</div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    permission: getPermission(state, op.permit),
  }
}

export default connect(mapStateToProps)(EasyPencilSection)
